import {
  ACTION_GET_CUSTOM_FIELDS,
  ACTION_GET_CUSTOM_FIELDS_SUCCESS,
  ACTION_GET_CUSTOM_FIELDS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

export function getCustomFields(orgId: string) {
  return (dispatch: Dispatch) => {
    dispatch({ type: ACTION_GET_CUSTOM_FIELDS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${orgId}/travel-custom-fields`,
        method: 'get',
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch({ type: ACTION_GET_CUSTOM_FIELDS_FAILURE, payload: response });
          } else {
            dispatch({ type: ACTION_GET_CUSTOM_FIELDS_SUCCESS, payload: response });
          }
        },
        fail: (error: any) => {
          dispatch({ type: ACTION_GET_CUSTOM_FIELDS_FAILURE, payload: error });
        },
      },
    });

    return null;
  };
}
